import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EonUiComponentsAngularModule } from '@eon-ui/eon-ui-components-angular';
import { AuthenticationService } from '../../service/authentication.service';
import { LegalLinksComponent } from '../../component/legal-links/legal-links.component';
import { IdentityProviderIdentifier } from '../../config/oauth2/idp.config';

@Component({
    selector: 'app-login-view',
    standalone: true,
    imports: [
        EonUiComponentsAngularModule,
        TranslateModule,
        LegalLinksComponent,
    ],
    templateUrl: './login-view.component.html',
    styleUrl: './login-view.component.scss',
})
export class LoginViewComponent {

    public token?: string;

    public get width(): number {
        return window.innerWidth;
    }

    constructor(private authenticationService: AuthenticationService) {
        this.token = this.authenticationService.getToken();
    }

    public login(idp: IdentityProviderIdentifier): void {
        this.authenticationService.useIdpAndLoadDiscoveryDocument(idp).then((_) => {
            this.authenticationService.login();
        });
    }
}
